module.exports = __webpack_public_path__ + "img/bg_title_nhrd.9ebd7973.png";